import React, { useState } from "react";
import * as XLSX from "xlsx";

const FileDownloader = () => {
  const [authSuccess, setAuthSuccess] = useState(false);
  const [option, setOption] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleAuth = () => {
    const password = prompt("Enter password:");
    if (password === "rama98@") {
      setAuthSuccess(true);
    } else {
      alert("Incorrect password!");
    }
  };

  const handleDownload = async () => {
    if (!option || !startDate || !endDate) {
      alert("Please select an option and date range.");
      return;
    }

    try {
      const response = await fetch("/get-file", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          option,
          startDate,
          endDate,
        }),
      });

      if (response.ok) {
        const jsonData = await response.json();

        // Convert JSON data to Excel
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

        // Create a Blob from the workbook
        const blob = new Blob(
          [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
          { type: "application/octet-stream" }
        );

        // Create a link to download the file
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${option}_${startDate}_${endDate}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert("File downloaded successfully!");
      } else {
        const errorData = await response.json();
        alert(`Failed to fetch data: ${errorData.error || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      alert("Error fetching or downloading the file.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {!authSuccess ? (
        <button onClick={handleAuth}>Authenticate</button>
      ) : (
        <div>
          <h2>Download Data</h2>
          <div>
            <label>
              Select Option:
              <select value={option} onChange={(e) => setOption(e.target.value)}>
                <option value="">-- Select --</option>
                <option value="ANM">ANM</option>
                <option value="GNM">GNM</option>
                <option value="B.ED">B.ED</option>
                <option value="ITI">ITI</option>
              </select>
            </label>
          </div>
          <div>
            <label>
              Start Date:
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </label>
          </div>
          <div>
            <label>
              End Date:
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </label>
          </div>
          <button onClick={handleDownload} style={{ marginTop: "10px" }}>
            Download Excel
          </button>
        </div>
      )}
    </div>
  );
};

export default FileDownloader;
